import { Link, useNavigate } from "react-router-dom";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import React from "react";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { RESETPASSWORD } from "../../../constants";
import { useAuth } from "../../../Context/AuthContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { PAGES } from "../../../routeConfig";
import $ from "jquery";
import { CancelButton } from "../../../Layout/Common/cancelButton";
export const ChangePassword = () => {
  const [showNewPassword, setshowNewPassword] = React.useState(false);
  const [showConformPassword, setshowConformPassword] = React.useState(false);
  const [showPassword, setshowPassword] = React.useState(false);

  const [txtOldPassword, settxtOldPassword] = React.useState("");
  const [txtNewPassword, settxtNewPassword] = React.useState("");
  const [txtConformPassword, settxtConformPassword] = React.useState("");
  const { showNoteAlert } = useNoteAlert();
  const [showerrorBorder, setshowerrorBorder] = React.useState(false);
  const { userId, userRole } = useAuth();

  const histroy = useNavigate();
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,32}$/;

  function isStrongPassword(pwd) {
    return passwordRegex.test(pwd);
  }

  const SubmitClick = () => {
    setshowerrorBorder(false);
    document.getElementById("divShowError").style.display = "none";
    var data = {
      OldPassword: txtOldPassword,
      NewPassword: txtNewPassword,
      ConformPassword: txtConformPassword,
      UserID: userId,
    };
    if (txtOldPassword == "") {
      showNoteAlert(RESETPASSWORD.EMPTYOLDPASSWORD, "PLEASE NOTE", true, () => {
        $("#changePwd1").focus();
      });
      return false;
    }
    if (txtNewPassword == "") {
      showNoteAlert(RESETPASSWORD.EMPTYPASSWORD, "PLEASE NOTE", true, () => {
        $("#changePwd2").focus();
      });
      return false;
    }
    if (txtConformPassword == "") {
      showNoteAlert(RESETPASSWORD.EMPTYCONFIRMPASSWORD, "PLEASE NOTE", true, () => {
        $("#changePwd3").focus();
      });
      return false;
    }

    if (txtNewPassword != txtConformPassword) {
      showNoteAlert(RESETPASSWORD.PASSWORDNOTMATCH, "PLEASE NOTE", true, () => {
        $("#changePwd2").focus();
      });
      var focusID = document.getElementById("changePwd2");
      focusID.focus();
      return false;
    }

    var ValidatePassword = isStrongPassword(txtNewPassword);
    if (ValidatePassword == false) {
      setshowerrorBorder(!showerrorBorder);
      document.getElementById("divShowError").style.display = "block";
      var focusID = document.getElementById("changePwd2");
      focusID.focus();
      return false;
    }

    axiosInstance
      .post("changePassword/btnChange_Click", data)
      .then((response) => {
        if (response.data != "") {
          if (response.data != "Success") {
            localStorage.setItem("previousOrderModal", false);
            showNoteAlert(response.data);
          } else {
            settxtOldPassword("");
            settxtNewPassword("");
            settxtConformPassword("");
            document.getElementById("divUpdateSuccess").style.display = "block";
            document.getElementById("divShowDetails").style.display = "none";
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  return (
    <>
      <BreadCrumb
        data={[
          { name: "My Account", url: PAGES.MYACCOUNT },
          { name: "Change Password", url: PAGES.CHANGE_PASSWORD },
        ]}
      />
      <section className="myAccount-section">
        <div className="container-fluid container-lg" id="divShowDetails" style={{ display: "block" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header">
                  <h1 className="myaccount-title">Change Password</h1>
                </div>
              </div>
            </div>
            <div className="col-sm-8 col-md-6">
              <div className="row">
                <div className="col-lg-12 mt-3">
                  <div className="passwordInstructions">
                    <span className="wes-info-cc"></span>
                    <p>
                      Create a strong password with 8-32 characters, mixing uppercase, lowercase, numbers and symbol
                    </p>
                  </div>
                </div>
                <form className="mt-3">
                  <div className="col-md-12 col-lg-12">
                    <div className="floating-input changedPwd mb-3">
                      <input
                        id="changePwd1"
                        className="form-control form-input"
                        autocomplete="new-password"
                        type={showPassword ? "text" : "password"}
                        placeholder=""
                        required=""
                        value={txtOldPassword}
                        onChange={(changeEvent) => settxtOldPassword(changeEvent.target.value)}
                      />
                      <label for="changePwd1">Old Password</label>
                      <span
                        className={showPassword ? " wesPassword wes-eye" : "wesPassword wes-eye-slash"}
                        onClick={() => setshowPassword(!showPassword)}
                      ></span>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12">
                    <div className="floating-input changedPwd mb-3">
                      <input
                        id="changePwd2"
                        autocomplete="new-password"
                        className={
                          showerrorBorder ? "form-control form-input error-message" : "form-control form-input"
                        }
                        type={showNewPassword ? "text" : "password"}
                        placeholder=""
                        required=""
                        value={txtNewPassword}
                        onChange={(changeEvent) => settxtNewPassword(changeEvent.target.value)}
                      />
                      <label for="changePwd2">New Password</label>
                      <span
                        className={showNewPassword ? " wesPassword wes-eye" : "wesPassword wes-eye-slash"}
                        onClick={() => setshowNewPassword(!showNewPassword)}
                      ></span>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12">
                    <div className="floating-input changedPwd mb-3">
                      <input
                        id="changePwd3"
                        autocomplete="new-password"
                        className={
                          showerrorBorder ? "form-control form-input error-message" : "form-control form-input"
                        }
                        type={showConformPassword ? "text" : "password"}
                        placeholder=""
                        required=""
                        value={txtConformPassword}
                        onChange={(changeEvent) => settxtConformPassword(changeEvent.target.value)}
                      />
                      <label for="changePwd3">Confirm New Password</label>
                      <span
                        className={showConformPassword ? " wesPassword wes-eye" : "wesPassword wes-eye-slash"}
                        onClick={() => setshowConformPassword(!showConformPassword)}
                      ></span>
                    </div>
                  </div>
                  <div className="col-lg-12 mt-3" id="divShowError" style={{ display: "none" }}>
                    <div
                      className="toast show pwd-error-toast w-100 mt-3"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      <div className="toast-body fav-orderno-not d-flex align-content-center justify-content-between">
                        <div className="fav-ordernoNot-lft d-flex align-items-start justify-content-between">
                          <div>
                            <svg
                              width={47}
                              height={48}
                              viewBox="0 0 47 48"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect y={0.5} width={47} height={47} rx={23.5} fill="#F82643" fillOpacity={0.2} />
                              <rect x={3} y={3.5} width={41} height={41} rx={20.5} fill="#F82643" />
                              <path
                                d="M23.5 21.375V25.75"
                                stroke="white"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.5 32.2339H18.1975C15.1613 32.2339 13.8925 30.0639 15.3625 27.4126L18.0925 22.4951L20.665 17.8751C22.2225 15.0664 24.7775 15.0664 26.335 17.8751L28.9075 22.5039L31.6375 27.4214C33.1075 30.0726 31.83 32.2426 28.8025 32.2426H23.5V32.2339Z"
                                stroke="white"
                                strokeWidth={1.5}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.4952 28.375H23.5031"
                                stroke="white"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="pwd-ordernoNot-info">
                            <h5 className="fw-semibold">Password does not meet requirements</h5>
                            <p className="fw-medium col-fs-13 fs-14 m-0">Please Enter valid password</p>
                          </div>
                        </div>
                        <div className="ct-close">
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="toast"
                            aria-label="Close"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 mt-3">
                    <div className="accountBtns-list">
                      <div className="button-effect">
                        <button
                          type="button"
                          className="btn btn-products theme-primary"
                          onClick={SubmitClick}
                          data-bs-dismiss="modal"
                        >
                          Change Password
                        </button>
                      </div>
                      <CancelButton
                        onClick={() => {
                          histroy(PAGES.MYACCOUNT);
                        }}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid container-lg" id="divUpdateSuccess" style={{ display: "none" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="pwd-success-section">
                <div className="row">
                  <div className="col-md-12 col-lg-6 offset-lg-3">
                    <div className="loginVerification-wrapper text-center">
                      <div className="loginVerification-wrapperTitle">
                        <svg
                          className="loginVerification-check"
                          width={60}
                          height={61}
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M30 55.5C43.75 55.5 55 44.25 55 30.5C55 16.75 43.75 5.5 30 5.5C16.25 5.5 5 16.75 5 30.5C5 44.25 16.25 55.5 30 55.5Z"
                            stroke="#3BA429"
                            strokeWidth={3.375}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M19.375 30.4998L26.45 37.5748L40.625 23.4248"
                            stroke="#3BA429"
                            strokeWidth={3.375}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <h1 className="fw-semibold mt-4">Password Updated!</h1>
                        <p className="fs-14 fw-normal">
                          Your password has been changed successfully. Use your new password to login
                        </p>
                        <div className="button-effect loginPwd-updateBtn">
                          <form action={window.location.origin + "/api/Logout"} method="POST">
                            <div className="dropdown-myAccount-footer">
                              <button
                                type="submit"
                                className="btn btn-products btn-addcart"
                                style={{
                                  width: "200px",
                                  textAlign: "center",
                                  margin: "0 auto",
                                  fontSize: "14px",
                                }}
                              >
                                Back to Login
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
